// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/customer_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/customer_model.proto.
 */
export const file_bffuser_v1_customer_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_occto_master_model, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * PrivateGeneration は自家発 3 項目 (自家発有無・自家発容量・逆調契約)。
 *
 * @generated from message bffuser.v1.PrivateGeneration
 */
export type PrivateGeneration = Message<"bffuser.v1.PrivateGeneration"> & {
  /**
   * @generated from field: bool has = 1;
   */
  has: boolean;

  /**
   * @generated from field: optional google.type.Decimal capacity_kw = 2;
   */
  capacityKw?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal reverse_power_flow_contract_kw = 3;
   */
  reversePowerFlowContractKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.PrivateGeneration.
 * Use `create(PrivateGenerationSchema)` to create a new message.
 */
export const PrivateGenerationSchema: GenMessage<PrivateGeneration> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 0);

/**
 * SupplyPointMasterCheck は供給地点マスタとの照合結果。
 *
 * @generated from message bffuser.v1.SupplyPointMasterCheck
 */
export type SupplyPointMasterCheck = Message<"bffuser.v1.SupplyPointMasterCheck"> & {
  /**
   * @generated from field: bffuser.v1.SupplyPointMasterCheckKind kind = 1;
   */
  kind: SupplyPointMasterCheckKind;

  /**
   * @generated from field: repeated bffuser.v1.SupplyPointMasterMismatch mismatches = 2;
   */
  mismatches: SupplyPointMasterMismatch[];
};

/**
 * Describes the message bffuser.v1.SupplyPointMasterCheck.
 * Use `create(SupplyPointMasterCheckSchema)` to create a new message.
 */
export const SupplyPointMasterCheckSchema: GenMessage<SupplyPointMasterCheck> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 1);

/**
 * CustomerSupplyPoint は地点 (1 地点 = 1 契約) の表示用 projection。
 *
 * @generated from message bffuser.v1.CustomerSupplyPoint
 */
export type CustomerSupplyPoint = Message<"bffuser.v1.CustomerSupplyPoint"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: string customer_id = 2;
   */
  customerId: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * @generated from field: bffuser.v1.ContractStage contract_stage = 4;
   */
  contractStage: ContractStage;

  /**
   * 未設定 = 番号未定 (見込みのみ)。
   *
   * @generated from field: optional string supply_point_specific_number = 5;
   */
  supplyPointSpecificNumber?: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 6;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 7;
   */
  voltageClass: VoltageClass;

  /**
   * @generated from field: optional string retailer_business_code = 8;
   */
  retailerBusinessCode?: string;

  /**
   * @generated from field: optional string retailer_name = 9;
   */
  retailerName?: string;

  /**
   * @generated from field: google.type.Decimal contract_kw = 10;
   */
  contractKw?: Decimal;

  /**
   * @generated from field: google.type.Date supply_start_date = 11;
   */
  supplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date supply_end_date = 12;
   */
  supplyEndDate?: Date;

  /**
   * @generated from field: bffuser.v1.PrivateGeneration private_generation = 13;
   */
  privateGeneration?: PrivateGeneration;

  /**
   * @generated from field: optional google.protobuf.Timestamp lost_at = 14;
   */
  lostAt?: Timestamp;

  /**
   * @generated from field: optional string lost_by = 15;
   */
  lostBy?: string;

  /**
   * @generated from field: bffuser.v1.SupplyPointMasterCheck master_check = 16;
   */
  masterCheck?: SupplyPointMasterCheck;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 18;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 20;
   */
  updatedBy: string;

  /**
   * 契約電力の期間の全部 (開始日順)。先頭は供給開始日から始まる最初の期間で、その kW はこの一覧の先頭の値。
   * contract_kw はこの一覧のうち今日に効いている値。
   *
   * @generated from field: repeated bffuser.v1.KwPeriod kw_periods = 21;
   */
  kwPeriods: KwPeriod[];
};

/**
 * Describes the message bffuser.v1.CustomerSupplyPoint.
 * Use `create(CustomerSupplyPointSchema)` to create a new message.
 */
export const CustomerSupplyPointSchema: GenMessage<CustomerSupplyPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 2);

/**
 * CustomerSummary は需要家一覧の 1 行 (集計は backend が行う)。
 *
 * @generated from message bffuser.v1.CustomerSummary
 */
export type CustomerSummary = Message<"bffuser.v1.CustomerSummary"> & {
  /**
   * @generated from field: string customer_id = 1;
   */
  customerId: string;

  /**
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * @generated from field: string contractor_name = 3;
   */
  contractorName: string;

  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 4;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: repeated bffuser.v1.VoltageClass voltage_classes = 5;
   */
  voltageClasses: VoltageClass[];

  /**
   * @generated from field: int32 contracted_point_count = 6;
   */
  contractedPointCount: number;

  /**
   * @generated from field: int32 prospect_point_count = 7;
   */
  prospectPointCount: number;

  /**
   * @generated from field: google.type.Decimal contracted_kw_total = 8;
   */
  contractedKwTotal?: Decimal;

  /**
   * @generated from field: google.type.Decimal prospect_kw_total = 9;
   */
  prospectKwTotal?: Decimal;

  /**
   * 需要家の作成・更新の記録。updated_at は需要家名の更新 (UpdateCustomer) の楽観ロックの token。
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * 需要家の契約者 (UpdateCustomer で付け替える)。
   *
   * @generated from field: string contractor_id = 14;
   */
  contractorId: string;
};

/**
 * Describes the message bffuser.v1.CustomerSummary.
 * Use `create(CustomerSummarySchema)` to create a new message.
 */
export const CustomerSummarySchema: GenMessage<CustomerSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 3);

/**
 * KwPeriod は契約電力の期間: start_date から contract_kw。最初の期間の start_date は供給開始日。
 * 期間は次の期間の開始日の前日まで (最後は供給終了日まで)。
 *
 * @generated from message bffuser.v1.KwPeriod
 */
export type KwPeriod = Message<"bffuser.v1.KwPeriod"> & {
  /**
   * @generated from field: google.type.Date start_date = 1;
   */
  startDate?: Date;

  /**
   * @generated from field: google.type.Decimal contract_kw = 2;
   */
  contractKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.KwPeriod.
 * Use `create(KwPeriodSchema)` to create a new message.
 */
export const KwPeriodSchema: GenMessage<KwPeriod> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 4);

/**
 * KwPeriodList は契約電力の期間の一覧 (UpdateCustomerSupplyPoint で最初以外の期間を丸ごと置き換える)。
 *
 * @generated from message bffuser.v1.KwPeriodList
 */
export type KwPeriodList = Message<"bffuser.v1.KwPeriodList"> & {
  /**
   * @generated from field: repeated bffuser.v1.KwPeriod periods = 1;
   */
  periods: KwPeriod[];
};

/**
 * Describes the message bffuser.v1.KwPeriodList.
 * Use `create(KwPeriodListSchema)` to create a new message.
 */
export const KwPeriodListSchema: GenMessage<KwPeriodList> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 5);

/**
 * RetailerOption は契約の小売の選択肢。
 *
 * @generated from message bffuser.v1.RetailerOption
 */
export type RetailerOption = Message<"bffuser.v1.RetailerOption"> & {
  /**
   * @generated from field: string business_code = 1;
   */
  businessCode: string;

  /**
   * @generated from field: string business_name = 2;
   */
  businessName: string;
};

/**
 * Describes the message bffuser.v1.RetailerOption.
 * Use `create(RetailerOptionSchema)` to create a new message.
 */
export const RetailerOptionSchema: GenMessage<RetailerOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 6);

/**
 * CustomerOption は新規契約で既存の需要家を選ぶ時の選択肢。
 *
 * @generated from message bffuser.v1.CustomerOption
 */
export type CustomerOption = Message<"bffuser.v1.CustomerOption"> & {
  /**
   * @generated from field: string customer_id = 1;
   */
  customerId: string;

  /**
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 3;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: int32 point_count = 4;
   */
  pointCount: number;

  /**
   * その需要家が持つ供給地点特定番号 (失注を除く)。まだ無い (見込みだけ・地点なし) 時は未設定。
   *
   * @generated from field: optional string supply_point_number = 5;
   */
  supplyPointNumber?: string;
};

/**
 * Describes the message bffuser.v1.CustomerOption.
 * Use `create(CustomerOptionSchema)` to create a new message.
 */
export const CustomerOptionSchema: GenMessage<CustomerOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 7);

/**
 * ContractorOption は新しい需要家の契約者を既存から選ぶ時の選択肢。
 *
 * @generated from message bffuser.v1.ContractorOption
 */
export type ContractorOption = Message<"bffuser.v1.ContractorOption"> & {
  /**
   * @generated from field: string contractor_id = 1;
   */
  contractorId: string;

  /**
   * @generated from field: string contractor_name = 2;
   */
  contractorName: string;

  /**
   * @generated from field: int32 customer_count = 3;
   */
  customerCount: number;
};

/**
 * Describes the message bffuser.v1.ContractorOption.
 * Use `create(ContractorOptionSchema)` to create a new message.
 */
export const ContractorOptionSchema: GenMessage<ContractorOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 8);

/**
 * Contractor は契約者 (小売供給契約を結び請求を受ける法人)。
 *
 * @generated from message bffuser.v1.Contractor
 */
export type Contractor = Message<"bffuser.v1.Contractor"> & {
  /**
   * @generated from field: string contractor_id = 1;
   */
  contractorId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string billing_postal_code = 3;
   */
  billingPostalCode: string;

  /**
   * @generated from field: string billing_address = 4;
   */
  billingAddress: string;

  /**
   * @generated from field: string billing_attention = 5;
   */
  billingAttention: string;

  /**
   * @generated from field: string note = 6;
   */
  note: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 8;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 10;
   */
  updatedBy: string;
};

/**
 * Describes the message bffuser.v1.Contractor.
 * Use `create(ContractorSchema)` to create a new message.
 */
export const ContractorSchema: GenMessage<Contractor> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 9);

/**
 * ContractorListItem は契約者一覧の 1 行 (契約者 + 配下の集計)。
 *
 * @generated from message bffuser.v1.ContractorListItem
 */
export type ContractorListItem = Message<"bffuser.v1.ContractorListItem"> & {
  /**
   * @generated from field: bffuser.v1.Contractor contractor = 1;
   */
  contractor?: Contractor;

  /**
   * @generated from field: int32 customer_count = 2;
   */
  customerCount: number;

  /**
   * @generated from field: int32 supply_point_count = 3;
   */
  supplyPointCount: number;

  /**
   * @generated from field: repeated string customer_names = 4;
   */
  customerNames: string[];
};

/**
 * Describes the message bffuser.v1.ContractorListItem.
 * Use `create(ContractorListItemSchema)` to create a new message.
 */
export const ContractorListItemSchema: GenMessage<ContractorListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_model, 10);

/**
 * ContractStage は地点の区分。internalapi.v1.ContractStage と値名・番号を一致させる。
 *
 * @generated from enum bffuser.v1.ContractStage
 */
export enum ContractStage {
  /**
   * @generated from enum value: CONTRACT_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 見込み: 契約前の商談中。供給地点特定番号は任意 (番号未定でよい)。
   *
   * @generated from enum value: CONTRACT_STAGE_PROSPECT = 1;
   */
  PROSPECT = 1,

  /**
   * 契約: 供給地点特定番号と小売が必須。番号は訂正でき (R51)、小売はエリアを直して元の小売が新しいエリアに無い時だけ利用者が選び直す (R58)。
   *
   * @generated from enum value: CONTRACT_STAGE_CONTRACTED = 2;
   */
  CONTRACTED = 2,

  /**
   * 失注: 見込みが契約にならなかった記録。編集・削除・契約への切り替えができない。
   *
   * @generated from enum value: CONTRACT_STAGE_LOST = 3;
   */
  LOST = 3,
}

/**
 * Describes the enum bffuser.v1.ContractStage.
 */
export const ContractStageSchema: GenEnum<ContractStage> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_model, 0);

/**
 * SupplyPointMasterCheckKind は地点と供給地点マスタの番号による照合結果。
 *
 * @generated from enum bffuser.v1.SupplyPointMasterCheckKind
 */
export enum SupplyPointMasterCheckKind {
  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_CHECK_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_CHECK_KIND_MATCH = 1;
   */
  MATCH = 1,

  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_CHECK_KIND_NOT_IN_MASTER = 2;
   */
  NOT_IN_MASTER = 2,

  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_CHECK_KIND_MISMATCH = 3;
   */
  MISMATCH = 3,
}

/**
 * Describes the enum bffuser.v1.SupplyPointMasterCheckKind.
 */
export const SupplyPointMasterCheckKindSchema: GenEnum<SupplyPointMasterCheckKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_model, 1);

/**
 * SupplyPointMasterMismatch は照合で食い違った項目。
 *
 * @generated from enum bffuser.v1.SupplyPointMasterMismatch
 */
export enum SupplyPointMasterMismatch {
  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_MISMATCH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_MISMATCH_AREA = 1;
   */
  AREA = 1,

  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_MISMATCH_VOLTAGE = 2;
   */
  VOLTAGE = 2,

  /**
   * @generated from enum value: SUPPLY_POINT_MASTER_MISMATCH_RETAILER = 3;
   */
  RETAILER = 3,
}

/**
 * Describes the enum bffuser.v1.SupplyPointMasterMismatch.
 */
export const SupplyPointMasterMismatchSchema: GenEnum<SupplyPointMasterMismatch> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_model, 2);

/**
 * SupplyPointDeleteBlockedReason は地点を削除できない理由。
 *
 * @generated from enum bffuser.v1.SupplyPointDeleteBlockedReason
 */
export enum SupplyPointDeleteBlockedReason {
  /**
   * @generated from enum value: SUPPLY_POINT_DELETE_BLOCKED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPLY_POINT_DELETE_BLOCKED_REASON_LOST = 1;
   */
  LOST = 1,

  /**
   * @generated from enum value: SUPPLY_POINT_DELETE_BLOCKED_REASON_IN_SUPPLY_POINT_MASTER = 2;
   */
  IN_SUPPLY_POINT_MASTER = 2,

  /**
   * @generated from enum value: SUPPLY_POINT_DELETE_BLOCKED_REASON_HAS_ACTUALS = 3;
   */
  HAS_ACTUALS = 3,
}

/**
 * Describes the enum bffuser.v1.SupplyPointDeleteBlockedReason.
 */
export const SupplyPointDeleteBlockedReasonSchema: GenEnum<SupplyPointDeleteBlockedReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_model, 3);

/**
 * CustomerSupplyPointErrorReason は地点の操作が拒否された原因 (per-domain
 * reason。ErrorInfo の reason に値名が載る)。internalapi.v1 の同名 enum と
 * 値名・番号を一致させる。
 *
 * @generated from enum bffuser.v1.CustomerSupplyPointErrorReason
 */
export enum CustomerSupplyPointErrorReason {
  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CUSTOMER_REQUIRED = 1;
   */
  CUSTOMER_REQUIRED = 1,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CUSTOMER_NAME_REQUIRED = 2;
   */
  CUSTOMER_NAME_REQUIRED = 2,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CUSTOMER_NAME_TOO_LONG = 3;
   */
  CUSTOMER_NAME_TOO_LONG = 3,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CONTRACT_KW_NOT_POSITIVE = 4;
   */
  CONTRACT_KW_NOT_POSITIVE = 4,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_END_BEFORE_START = 5;
   */
  END_BEFORE_START = 5,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_SUPPLY_POINT_NUMBER_REQUIRED = 6;
   */
  SUPPLY_POINT_NUMBER_REQUIRED = 6,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_SUPPLY_POINT_NUMBER_INVALID = 7;
   */
  SUPPLY_POINT_NUMBER_INVALID = 7,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_SUPPLY_POINT_NUMBER_IMMUTABLE = 8;
   */
  SUPPLY_POINT_NUMBER_IMMUTABLE = 8,

  /**
   * metadata supply_point_number に番号。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_PERIOD_OVERLAP = 9;
   */
  PERIOD_OVERLAP = 9,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_RETAILER_REQUIRED = 10;
   */
  RETAILER_REQUIRED = 10,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_RETAILER_NOT_IN_AREA = 11;
   */
  RETAILER_NOT_IN_AREA = 11,

  /**
   * metadata area_code にエリア。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_RETAILER_UNAVAILABLE_IN_AREA = 12;
   */
  RETAILER_UNAVAILABLE_IN_AREA = 12,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_PRIVATE_GENERATION_CAPACITY_REQUIRED = 13;
   */
  PRIVATE_GENERATION_CAPACITY_REQUIRED = 13,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_REVERSE_POWER_FLOW_REQUIRED = 14;
   */
  REVERSE_POWER_FLOW_REQUIRED = 14,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_REVERSE_POWER_FLOW_OUT_OF_RANGE = 15;
   */
  REVERSE_POWER_FLOW_OUT_OF_RANGE = 15,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_STAGE_TRANSITION_NOT_ALLOWED = 16;
   */
  STAGE_TRANSITION_NOT_ALLOWED = 16,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CONTRACT_IN_USE = 17;
   */
  CONTRACT_IN_USE = 17,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_ACTUALS_CHECK_UNAVAILABLE = 18;
   */
  ACTUALS_CHECK_UNAVAILABLE = 18,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CONFLICT = 19;
   */
  CONFLICT = 19,

  /**
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CONTRACTOR_REQUIRED = 20;
   */
  CONTRACTOR_REQUIRED = 20,

  /**
   * 既存の需要家に別のエリアの地点は足せない。metadata customer_name に需要家名、area_code にその需要家のエリア。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CUSTOMER_AREA_MISMATCH = 21;
   */
  CUSTOMER_AREA_MISMATCH = 21,

  /**
   * 既存の需要家に別の供給地点特定番号の地点は足せない。metadata customer_name、supply_point_number (その需要家の番号)。
   * 番号が未定の見込みを番号のある需要家に足す時は number_blank=true。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_CUSTOMER_NUMBER_MISMATCH = 22;
   */
  CUSTOMER_NUMBER_MISMATCH = 22,

  /**
   * 供給地点マスタに載っている・託送実績のある契約の番号は直せない。供給終了日で前の契約を終わらせ、正しい番号で次の契約を登録する。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_SUPPLY_POINT_NUMBER_NOT_EDITABLE = 23;
   */
  SUPPLY_POINT_NUMBER_NOT_EDITABLE = 23,

  /**
   * 番号の先頭 2 桁が表すエリアと、地点のエリアが違う。metadata supply_point_number、area_code (番号のエリア)。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_SUPPLY_POINT_NUMBER_AREA_MISMATCH = 24;
   */
  SUPPLY_POINT_NUMBER_AREA_MISMATCH = 24,

  /**
   * 契約電力の期間の適用開始日が供給期間の外 (供給開始日以前・供給終了日より後)、または同じ日に 2 つある。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_KW_PERIOD_INVALID = 25;
   */
  KW_PERIOD_INVALID = 25,

  /**
   * 契約電力の変更が 120 件を超えている (判断台帳 R61。最初の期間は数えず、2 件目以降の期間の数)。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_KW_PERIODS_TOO_MANY = 26;
   */
  KW_PERIODS_TOO_MANY = 26,

  /**
   * エリアを直した時に、新しいエリアでも選べる登録済みの小売とは別の小売が指定された (判断台帳 R58)。
   *
   * @generated from enum value: CUSTOMER_SUPPLY_POINT_ERROR_REASON_RETAILER_NOT_CHANGEABLE = 27;
   */
  RETAILER_NOT_CHANGEABLE = 27,
}

/**
 * Describes the enum bffuser.v1.CustomerSupplyPointErrorReason.
 */
export const CustomerSupplyPointErrorReasonSchema: GenEnum<CustomerSupplyPointErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_model, 4);

/**
 * ContractorErrorReason は契約者の操作が拒否された原因 (per-domain reason)。
 * internalapi.v1 の同名 enum と値名・番号を一致させる。
 *
 * @generated from enum bffuser.v1.ContractorErrorReason
 */
export enum ContractorErrorReason {
  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_NAME_REQUIRED = 1;
   */
  NAME_REQUIRED = 1,

  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_NAME_TOO_LONG = 2;
   */
  NAME_TOO_LONG = 2,

  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_POSTAL_CODE_TOO_LONG = 3;
   */
  POSTAL_CODE_TOO_LONG = 3,

  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_ADDRESS_TOO_LONG = 4;
   */
  ADDRESS_TOO_LONG = 4,

  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_ATTENTION_TOO_LONG = 5;
   */
  ATTENTION_TOO_LONG = 5,

  /**
   * @generated from enum value: CONTRACTOR_ERROR_REASON_NOTE_TOO_LONG = 6;
   */
  NOTE_TOO_LONG = 6,

  /**
   * metadata customer_count に件数。
   *
   * @generated from enum value: CONTRACTOR_ERROR_REASON_HAS_CUSTOMERS = 7;
   */
  HAS_CUSTOMERS = 7,
}

/**
 * Describes the enum bffuser.v1.ContractorErrorReason.
 */
export const ContractorErrorReasonSchema: GenEnum<ContractorErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_model, 5);

